document.addEventListener("DOMContentLoaded", () => {

	// Function to format money properly
	const formatMoney = (cents) => {
		return (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
	};
	

	// Function to check total stock availability for a product variant
	const getTotalVariantQuantity = (variantId) => {
		let totalQuantity = 0;
		document.querySelectorAll(`.cart_item[data-id="${variantId}"]`).forEach((row) => {
			totalQuantity += parseInt(row.querySelector(".quantity-input").value, 10);
		});
		return totalQuantity;
	};

	// Function to update line total without AJAX
	const updateLineTotal = (row, quantity) => {
		const lineTotalElement = row.querySelector(".line-total");
		const totalPrice = lineTotalElement.querySelector(".total");
		const price = parseFloat(lineTotalElement.dataset.price);
		
		if (!isNaN(price)) {
			const lineTotal = price * quantity;
			totalPrice.textContent = formatMoney(lineTotal);
			
			// Also update cart total
			updateCartTotalManually();
		}
	};
	
	// Function to update cart total manually without AJAX
	const updateCartTotalManually = () => {
		let cartTotal = 0;
		let itemCount = 0;

		document.querySelectorAll(".cart_item[data-line]").forEach((row) => {
			const quantity = parseInt(row.querySelector(".quantity-input").value, 10);
			const price = parseFloat(row.querySelector(".line-total").dataset.price);
			
			// Calculate line total with VAT if applicable
			const lineTotal = price * quantity;

			// Add to cart total
			cartTotal += lineTotal;
			itemCount += quantity;
		});
		
		// Update cart total
		document.getElementById("cart-total").textContent = formatMoney(cartTotal);
		
		// Update cart count bubble
		document.querySelectorAll(".js_cart-count").forEach((el) => {
			el.textContent = itemCount;
		});
	};

	// Function to update cart via AJAX
	const updateCart = (line, quantity) => {
		const row = document.querySelector(`.cart_item[data-line="${line}"]`);
		const lineTotalElement = row.querySelector(".line-total");
		const totalPrice = lineTotalElement.querySelector(".total");
		const loadingIcon = lineTotalElement.querySelector(".loading");

		// Show loading icon and hide total price
		totalPrice.classList.add("hidden");
		loadingIcon.classList.remove("hidden");
		
		// Update the line total immediately for better UX
		updateLineTotal(row, quantity);

		fetch("/cart/change.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ line, quantity }),
		})
		.then(response => response.json())
		.then(data => {
			// Hide loading icon and show updated total price
			totalPrice.classList.remove("hidden");
			loadingIcon.classList.add("hidden");

			// Remove line item from cart display
			if (quantity === 0 && data.item_count > 0) {
				document.querySelector(`.cart_item[data-line="${line}"]`).remove();
				updateCartTotalManually();
			} else if (quantity > 0) {
				// Update the quantity input value to match the actual quantity
				const quantityInput = row.querySelector('.quantity-input');
				if (quantityInput) {
					quantityInput.value = quantity;
				}

				// Update the line total based on the new quantity
				updateLineTotal(row, quantity);
			}

			// If the cart is empty, delay the reload slightly
			if (data.item_count === 0) {
				setTimeout(() => location.reload(), 200);
			}
		})
		.catch(error => {
			console.error("Error updating cart:", error);
			// Hide loading icon and show updated total price even on error
			totalPrice.classList.remove("hidden");
			loadingIcon.classList.add("hidden");
		});
	};

	// On load, check if products quantity exceedss current stock
	const checkStockOnLoad = () => {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cartData => {
                cartData.items.forEach((item, index) => {
                    const cartItem = document.querySelector(`.cart_item[data-id="${item.id}"]`);
                    if (cartItem) {
                        const stock = parseInt(cartItem.dataset.stock, 10);
                        const quantityInput = cartItem.querySelector(".quantity-input");

                        if (item.quantity > stock) {
                            quantityInput.value = stock;
                            updateCart(index + 1, stock);
                        }
                    }
                });
            })
            .catch(error => console.error("Error fetching cart data:", error));
    };
	checkStockOnLoad();
	
	// Handle quantity changes
	document.querySelectorAll(".quantity-input").forEach((input) => {
		input.addEventListener("change", (event) => {
			const inputElement = event.target;
			const line = inputElement.dataset.line;
			const cartItem = inputElement.closest(".cart_item");
			const variantId = cartItem.dataset.id;
			let quantity = parseInt(inputElement.value, 10);
			const maxStock = parseInt(cartItem.dataset.stock, 10);
			const errorMessage = cartItem.querySelector(".quantity-error");
			const totalQuantity = getTotalVariantQuantity(variantId);
	
			// Prevent quantity from being less than 1
			if (isNaN(quantity) || quantity < 1) {
				inputElement.value = 1; // Reset input value to 1
				return;
			}
	
			// Ensure quantity does not exceed stock limits
			if (totalQuantity > maxStock) {
				quantity = maxStock - (totalQuantity - quantity);
				if (quantity < 1) quantity = 1;
				inputElement.value = quantity;
				errorMessage.classList.remove("hidden");
			} else {
				errorMessage.classList.add("hidden");
				updateCart(line, quantity);
			}
		});
	});	
	
	// Handle quantity increase
	document.querySelectorAll(".quantity-input__more").forEach((button) => {
		button.addEventListener("click", (event) => {
			const cartItem = event.target.closest(".cart_item");
			const input = cartItem.querySelector(".quantity-input");
			const variantId = cartItem.dataset.id;
			const maxStock = parseInt(cartItem.dataset.stock, 10);
			const newQuantity = parseInt(input.value, 10) + 1;
			const errorMsg = cartItem.querySelector(".quantity-error");

			const totalQuantity = getTotalVariantQuantity(variantId);

			if (totalQuantity >= maxStock) {
				errorMsg.classList.remove("hidden");
			} else {
				errorMsg.classList.add("hidden");
				
				// Update the input value immediately for visual feedback
				input.value = newQuantity;
				
				// Update the line total immediately
				updateLineTotal(cartItem, newQuantity);
				
				// Then update the cart via AJAX
				updateCart(input.dataset.line, newQuantity);
			}
		});
	});
	
	// Handle quantity decrease
	document.querySelectorAll(".quantity-input__less").forEach((button) => {
		button.addEventListener("click", (event) => {
			const cartItem = event.target.closest(".cart_item");
			const input = cartItem.querySelector(".quantity-input");
			let newQuantity = parseInt(input.value, 10) - 1;
			const errorMessage = cartItem.querySelector(".quantity-error");

			if (newQuantity < 1 || isNaN(newQuantity)) {
				newQuantity = 1;
			} else {
				// Update the input value immediately for visual feedback
				input.value = newQuantity;
				
				// Update the line total immediately
				updateLineTotal(cartItem, newQuantity);
				
				// Then update the cart via AJAX
				updateCart(input.dataset.line, newQuantity);
				errorMessage.classList.add("hidden");
			}
		});
	});
	
	// Handle item removal
	document.querySelectorAll(".remove-item").forEach((button) => {
		button.addEventListener("click", (event) => {
			let buttonElement = event.target.closest(".remove-item");
			if (!buttonElement) return;
			let line = buttonElement.dataset.line;
			// Change opacity for visual feedback
			buttonElement.closest(".cart_item").classList.add("opacity-50");
			// Update cart
			updateCart(line, 0);
		});
	});

	// Function to update all prices with VAT
	const updateAllPricesWithVAT = () => {
		// Update individual product prices
		document.querySelectorAll('.js-product-price').forEach(priceElement => {
			const originalPrice = parseFloat(priceElement.getAttribute('data-price'));
			
			if (!isNaN(originalPrice)) {
				const finalPrice = originalPrice;
				
				// Update the price text
				priceElement.textContent = formatMoney(finalPrice);
			}
		});
		
		// Update line totals
		document.querySelectorAll('.cart_item[data-line]').forEach(row => {
			const quantity = parseInt(row.querySelector('.quantity-input').value, 10);
			updateLineTotal(row, quantity);
		});
		
		// Update cart total
		updateCartTotalManually();
	};

	// Run the initial price update
	updateAllPricesWithVAT();

	// Initialize cart total on page load
	updateCartTotalManually();

	// Envoie les notes d'instruction de livraison dans le champ note de la commande
	function sendDeliveryInstructions() {
		const cartForm = document.getElementById("cart");
		const notesField = document.getElementById("CartNote");
		
		if (cartForm && notesField) {
			cartForm.addEventListener("submit", function (event) {
				// Vérifier si c'est le bouton checkout qui a déclenché la soumission
				const submitter = event.submitter;
				if (submitter && submitter.id === "checkout") {
					event.preventDefault();
					event.stopPropagation();

					const clientNote = notesField.value.trim();

					// Récupérer d'abord la note actuelle du panier pour préserver les notes existantes (ex: Colissimo)
					fetch("/cart.js")
						.then(response => {
							if (!response.ok) {
								throw new Error(`HTTP error! status: ${response.status}`);
							}
							return response.json();
						})
						.then(cartData => {
							let existingNote = cartData.note || "";
							let finalNote = "";

							// Si le client a ajouté un commentaire
							if (clientNote !== "") {
								// Si une note existe déjà (ex: de Colissimo)
								if (existingNote.trim() !== "") {
									// Vérifier si le commentaire du client n'est pas déjà dans la note
									if (!existingNote.includes(clientNote)) {
										// Combiner les notes : note existante + commentaire client
										finalNote = existingNote.trim() + "\n\n--- Commentaire client ---\n" + clientNote;
									} else {
										// Le commentaire est déjà présent, garder la note existante
										finalNote = existingNote;
									}
								} else {
									// Pas de note existante, utiliser uniquement le commentaire client
									finalNote = clientNote;
								}
							} else {
								// Pas de commentaire client, garder la note existante
								finalNote = existingNote;
							}

							// Mettre à jour la note du panier
							return fetch("/cart/update.js", {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: JSON.stringify({ note: finalNote })
							});
						})
						.then(response => {
							if (!response.ok) {
								throw new Error(`HTTP error! status: ${response.status}`);
							}
							return response.json();
						})
						.then(() => {
							window.location.href = "/checkout";
						})
						.catch(error => {
							console.error("Erreur lors de la mise à jour du panier :", error);
							// En cas d'erreur, rediriger quand même vers le checkout
							window.location.href = "/checkout";
						});
				}
			});
		}
	}

	// Initialiser la fonction d'envoi des notes
	sendDeliveryInstructions();
});
